const PENDING_KEY = 'fflboss_unprinted_4473_pending';
const COUNT_KEY = 'fflboss_unprinted_4473_count';
const DISMISSED_COUNT_KEY = 'fflboss_unprinted_4473_dismissed_count';
const THRESHOLD = 3;

const getStorage = () => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return null;
	}
	return window.localStorage;
};

const getPending = () => {
	const storage = getStorage();
	if (!storage) {
		return [];
	}

	try {
		const pending = JSON.parse(storage.getItem(PENDING_KEY) || '[]');
		return Array.isArray(pending) ? pending : [];
	} catch (e) {
		return [];
	}
};

const setPending = (pending) => {
	const storage = getStorage();
	if (!storage) {
		return;
	}

	storage.setItem(PENDING_KEY, JSON.stringify(pending));
};

const getNumber = (key) => {
	const storage = getStorage();
	if (!storage) {
		return 0;
	}

	const value = parseInt(storage.getItem(key), 10);
	return Number.isNaN(value) ? 0 : value;
};

const setNumber = (key, value) => {
	const storage = getStorage();
	if (!storage) {
		return;
	}

	storage.setItem(key, String(value));
};

export const mark4473PrintExpected = (transactionId) => {
	if (!transactionId) {
		return;
	}

	const pending = getPending();
	if (pending.find(entry => entry.transactionId === transactionId)) {
		return;
	}

	setPending([
		...pending,
		{
			transactionId,
			created: new Date().toISOString()
		}
	]);
};

export const mark4473Printed = (transactionId) => {
	if (!transactionId) {
		return;
	}

	setPending(getPending().filter(entry => entry.transactionId !== transactionId));
};

export const recordUnprinted4473IfNeeded = (transactionId) => {
	if (!transactionId) {
		return;
	}

	const pending = getPending();
	const hasPendingPrint = pending.find(entry => entry.transactionId === transactionId);
	if (!hasPendingPrint) {
		return;
	}

	setPending(pending.filter(entry => entry.transactionId !== transactionId));
	setNumber(COUNT_KEY, getUnprinted4473Count() + 1);
};

export const getUnprinted4473Count = () => getNumber(COUNT_KEY);

export const shouldShowUnprinted4473Reminder = () => {
	const count = getUnprinted4473Count();
	return count >= THRESHOLD && getNumber(DISMISSED_COUNT_KEY) < count;
};

export const dismissUnprinted4473Reminder = () => {
	setNumber(DISMISSED_COUNT_KEY, getUnprinted4473Count());
};
